// extracted by mini-css-extract-plugin
module.exports = {"item":"Histogram_item__v88F5"};